export default __webpack_public_path__ + "static/media/alheli-products.8ed8ffda.jpg";